import * as React from 'react';

import { Button, Props as ButtonProps } from '../Button';
import { classes } from '../utils';

import styles from './styles.module.css';

type PhoenixRoundedButtonProps = {
  colorMode?: 'light' | 'dark';
  appearance?: 'fill' | 'outline';
  size?: 'small' | 'default' | 'large';
};

export type RoundedButtonProps = Omit<ButtonProps, 'size'> &
  PhoenixRoundedButtonProps & {
    /** @deprecated deprecated with no replacement */
    selected?: boolean;

    /** @deprecated deprecated with no replacement */
    description?: string;

    /** @deprecated deprecated with no replacement */
    error?: boolean;
  };

export const RoundedButton = React.forwardRef<
  HTMLButtonElement,
  RoundedButtonProps
>(function RoundedButtonComponent(props: RoundedButtonProps, ref) {
  const {
    children,
    name = 'roundedButton',
    // default RoundedButton version to 'phoenix' since the previous
    // rounded button component has been deprecated since about version 3
    version = 'phoenix',
    colorMode = 'light',
    appearance = 'outline',
    size = 'default',
    ...rest
  } = props;

  const hasIcon = Boolean(props.Icon && props.iconPosition !== 'none');

  const cx = classes(
    [
      styles[`roundedButton-${version}`],
      styles[colorMode],
      styles[appearance],
      styles[size],
      styles.smallIcon,
      {
        [styles.hasIcon]: hasIcon,
      },
    ],
    {
      unstyled: props.unstyled,
      className: props.className,
      name: props.name,
    }
  );

  return (
    <Button {...rest} version={version} className={cx} ref={ref} name={name}>
      {children}
    </Button>
  );
});
